module.exports = __webpack_public_path__ + "img/SES_205142550.44f2ecae.jpg";